
import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import { StoreModel } from "@/models/store";
import { MeasureModel } from "@/models/measure";
import { DimensionModel } from "@/models/dimension";
import { AnalyticsTypeModel } from "@/models/analytics_type";
import { ProductSegmentModel } from "@/models/product_segment";
import { FilterColumnList } from "@/collections/filter_columns";
import FilterColumn from "@/components/FilterColumn.vue";
import { MeasureList } from "@/collections/measures";
import ActionButton from "@/components/ActionButton.vue";
import SegmentSelector from "@/components/SegmentSelector.vue";
import { EventBus } from "@/main";

@Component({
  components: {
    FilterColumn,
    ActionButton,
    SegmentSelector,
  },
})
export default class ReportFilter extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: () => new MeasureList() })
  public measures!: MeasureList;
  @Prop({ default: () => new MeasureModel() })
  public measure!: MeasureModel;


  public dimension: DimensionModel = new DimensionModel();

  public analyticsType: AnalyticsTypeModel = new AnalyticsTypeModel();
  public dates: string[] = [];
  public filterColumns: FilterColumnList = new FilterColumnList();
  @Prop({ default: () => new FilterColumnList() })
  public initFilterColumns!: FilterColumnList;
  @Prop({ default: () => [] })
  public reportColumns!: any;
  public productSegment: ProductSegmentModel = new ProductSegmentModel();
  @Prop({ default: () => new ProductSegmentModel() })
  public initProductSegment!: ProductSegmentModel;
  public filterDialog: boolean = false;
  @Prop({ default: false })
  public isPrimaryButton!: boolean;
  @Prop({ default: "Filter" })
  public buttonTitle!: string;
  @Prop({ default: "mdi-filter" })
  public buttonIcon!: string;
  @Prop({ default: "small" })
  public buttonSize!: string;

  @Prop({ default: "Apply Filters" })
  public applyButtonTitle!: string;
  @Prop({ default: "mdi-check" })
  public applyButtonIcon!: string;
  @Prop({ default: "primary" })
  public applyButtonColor!: string;
  @Prop({ default: "white" })
  public applyButtonTextColor!: string;
  @Prop({ default: "36" })
  public applyButtonHeight!: string;
  @Prop({ default: false })
  public hideProductSegment!: boolean;
  public async created() {
    EventBus.$on("show-product-filter-dialog", () => {
      this.filterDialog = true;
    });
  }

  public get isPinMenu() {
    return localStorage.getItem('isPinMenu') === 'true';
  }

  public async mounted() {
    this.filterColumns = this.initFilterColumns;
    this.productSegment = this.initProductSegment;
  }

  public get getButtonTitle() {
    if (this.filterColumns.items.length > 0) {
      return `${this.buttonTitle} (${this.filterColumns.items.length} active)`;
    }
    return this.buttonTitle;
  }
  public applyFilter() {
    this.$emit("input", {
      filterColumns: this.filterColumns,
      productSegment: this.productSegment,
    });
    this.filterDialog = false;
  }

  public clearFilter() {
    this.productSegment = new ProductSegmentModel();
    this.filterColumns = new FilterColumnList();
    this.$emit("input", {
      filterColumns: this.filterColumns,
      productSegment: this.productSegment,
    });
    this.filterDialog = false;
    EventBus.$emit("clear-filter-column");
    EventBus.$emit("reload-report-data");
  }

  //Watch initFilterColumns if it changed then update filterColumns
  @Watch("initFilterColumns")
  private onInitFilterColumnsChanged(newVal: any, oldVal: any) {
    this.filterColumns = this.initFilterColumns;
    this.applyFilter();
  }

  //Watch initProductSegment if it changed then update productSegment
  @Watch("initProductSegment", { deep: true })
  private onInitProductSegmentChanged(newVal: any, oldVal: any) {
    this.productSegment = this.initProductSegment;
  }

  // New computed property
  public get hasActiveFilters(): boolean {
    return this.filterColumns.items.length > 0 || !!this.productSegment.id;
  }

  // New method to remove individual filter
  public removeFilter(filter: any) {
    const index = this.filterColumns.items.findIndex(f => f.code === filter.code);
    if (index > -1) {
      this.filterColumns.items.splice(index, 1);
    }
  }
}
